import React from 'react';
import styled from 'styled-components';
import { type FileData } from '../types';
import FileTree from './FileTree';

interface SidebarProps {
  isOpen: boolean;
  files: FileData[];
  selectedFile: FileData | null;
  onFileSelect: (file: FileData) => void;
}

let SidebarContainer = styled.aside<{ isOpen: boolean }>`
  width: 16rem;
  background-color: #111;
  border-right: 1px solid #222;
  overflow-y: auto;
  transition: transform 0.3s ease-in-out;
  height: calc(100vh - 3.5rem);
  z-index: 10;

  position: absolute;
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(-100%)')};

  @media (min-width: 1024px) {
    position: relative;
    transform: translateX(0);
  }
`;

let TreeWrapper = styled.div`
  padding: 0.5rem;
`;

let Sidebar: React.FC<SidebarProps> = ({ isOpen, files, selectedFile, onFileSelect }) => {
  return (
    <SidebarContainer isOpen={isOpen}>
      {/* <Header>
        <HeaderText>Explorer</HeaderText>
      </Header> */}
      <TreeWrapper>
        <FileTree files={files} onFileSelect={onFileSelect} selectedFile={selectedFile} />
      </TreeWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
